import {
  DOCUMENT_ALL, DOCUMENT_GET, DOCUMENT_POST, DOCUMENT_PUT, DOCUMENT_DEL,
  DOCUMENT_RESET, DOCUMENT_LOADING, DOCUMENT_ERROR,
} from '../types';
import api from '../../../utils/functions/api';

const BASE = `${process.env.REACT_APP_API_URL}/documents`;

// helper: ดึง error message ที่มีความหมายจาก axios error
function extractMessage(error) {
  return (
    error?.response?.data?.error?.message ||
    error?.response?.data?.message ||
    error?.message ||
    'เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ'
  );
}

export const documentAll = (params = {}) => async (dispatch) => {
  try {
    const { type = '', status = '', project_id = '', q = '', page = 1, limit = 20 } = params;
    const { data } = await api.get(
      `${BASE}?type=${type}&status=${status}&project_id=${project_id}&q=${q}&page=${page}&limit=${limit}`,
    );
    dispatch({ type: DOCUMENT_ALL, payload: data });
  } catch (error) {
    dispatch({ type: DOCUMENT_ERROR });
    throw new Error(extractMessage(error));
  }
};

export const documentGet = (id) => async (dispatch) => {
  try {
    const { data } = await api.get(`${BASE}/${id}`);
    dispatch({ type: DOCUMENT_GET, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: DOCUMENT_ERROR });
    throw new Error(extractMessage(error));
  }
};

export const documentCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: DOCUMENT_LOADING });
    const { data } = await api.post(BASE, payload);
    dispatch({ type: DOCUMENT_POST, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: DOCUMENT_ERROR });
    const err = new Error(extractMessage(error));
    err.code = error?.response?.data?.error?.code;
    err.suggested = error?.response?.data?.error?.suggested;
    throw err;
  }
};

export const documentUpdate = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: DOCUMENT_LOADING });
    const { data } = await api.patch(`${BASE}/${id}`, payload);
    dispatch({ type: DOCUMENT_PUT, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: DOCUMENT_ERROR });
    throw new Error(extractMessage(error));
  }
};

export const documentChangeStatus = (id, status) => async (dispatch) => {
  try {
    dispatch({ type: DOCUMENT_LOADING });
    const { data } = await api.patch(`${BASE}/${id}/status`, { status });
    dispatch({ type: DOCUMENT_PUT, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: DOCUMENT_ERROR });
    throw new Error(extractMessage(error));
  }
};

export const documentDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: DOCUMENT_LOADING });
    await api.delete(`${BASE}/${id}`);
    dispatch({ type: DOCUMENT_DEL, payload: { id } });
  } catch (error) {
    dispatch({ type: DOCUMENT_ERROR });
    throw new Error(extractMessage(error));
  }
};

export const documentFindLatest = ({ type, status = 'approved', project_id }) => async () => {
  try {
    const { data } = await api.get(
      `${BASE}?type=${type}&status=${status}&project_id=${project_id}&page=1&limit=5`,
    );
    return Array.isArray(data?.rows) ? data.rows : [];
  } catch {
    return [];
  }
};

export const documentPreviewNumber = (type) => async () => {
  try {
    const { data } = await api.get(`${BASE}/preview-number?type=${type}`);
    return data?.document_number || '';
  } catch {
    return '';
  }
};

export const documentGetChain = (id) => async (dispatch) => {
  try {
    const { data } = await api.get(`${BASE}/${id}/chain`);
    return data;
  } catch (error) {
    throw new Error(extractMessage(error));
  }
};

export const documentDuplicate = (id) => async (dispatch) => {
  try {
    dispatch({ type: DOCUMENT_LOADING });
    const { data } = await api.post(`${BASE}/${id}/duplicate`);
    dispatch({ type: DOCUMENT_POST, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: DOCUMENT_ERROR });
    throw new Error(extractMessage(error));
  }
};

export const documentCreateDelivery = (parentId, payload) => async (dispatch) => {
  try {
    dispatch({ type: DOCUMENT_LOADING });
    const { data } = await api.post(`${BASE}/${parentId}/create-delivery`, payload);
    dispatch({ type: DOCUMENT_POST, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: DOCUMENT_ERROR });
    throw new Error(extractMessage(error));
  }
};

export const documentCreateBilling = (parentId, payload) => async (dispatch) => {
  try {
    dispatch({ type: DOCUMENT_LOADING });
    const { data } = await api.post(`${BASE}/${parentId}/create-billing`, payload);
    dispatch({ type: DOCUMENT_POST, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: DOCUMENT_ERROR });
    throw new Error(extractMessage(error));
  }
};

export const documentCreateReceipt = (parentId, payload) => async (dispatch) => {
  try {
    dispatch({ type: DOCUMENT_LOADING });
    const { data } = await api.post(`${BASE}/${parentId}/create-receipt`, payload);
    dispatch({ type: DOCUMENT_POST, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: DOCUMENT_ERROR });
    throw new Error(extractMessage(error));
  }
};

export const documentCreateInvoice = (parentId, payload) => async (dispatch) => {
  try {
    dispatch({ type: DOCUMENT_LOADING });
    const { data } = await api.post(`${BASE}/${parentId}/create-invoice`, payload);
    dispatch({ type: DOCUMENT_POST, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: DOCUMENT_ERROR });
    throw new Error(extractMessage(error));
  }
};

export const documentCreateReceiptInvoice = (parentId, payload) => async (dispatch) => {
  try {
    dispatch({ type: DOCUMENT_LOADING });
    const { data } = await api.post(`${BASE}/${parentId}/create-receipt-invoice`, payload);
    dispatch({ type: DOCUMENT_POST, payload: data.receipt });
    return data;
  } catch (error) {
    dispatch({ type: DOCUMENT_ERROR });
    throw new Error(extractMessage(error));
  }
};

export const documentGroupedByProject = (params = {}) => async () => {
  try {
    const { q = '', archived = '' } = params;
    const { data } = await api.get(`${BASE}/grouped-by-project?q=${q}&archived=${archived}`);
    return data;
  } catch (error) {
    throw new Error(extractMessage(error));
  }
};

export const documentReset = () => async (dispatch) => {
  dispatch({ type: DOCUMENT_RESET });
};
